import { FC } from 'react'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import styles from '../EditClaimCardMainInformation.module.css'
import plusIcon from '../../../assets/icons/plusIcon.svg'
import { useMediaQuery } from 'react-responsive'

interface ClientInformationSectionProps {
  values: any
  clientType: 'individual' | 'legal'
  selectedClient: any
  clients: any[]
  clientOptions: any[]
  loadOptions: (inputValue: string, callback: (options: any[]) => void) => void
  setClientType: (type: 'individual' | 'legal') => void
  setSelectedClient: (client: any) => void
  setFieldValue: (field: string, value: any) => void
  handleBlur: (e: any) => void
  onOpenCreateClient: () => void
}

export const ClientInformationSection: FC<ClientInformationSectionProps> = ({
  values,
  clientType,
  selectedClient,
  clients,
  clientOptions,
  loadOptions,
  setClientType,
  setSelectedClient,
  setFieldValue,
  handleBlur,
  onOpenCreateClient,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Информация о клиенте</div>
      <div className={styles.sectionContent}>
        <div className={styles.clientBlock}>
          <div className={styles.leftBlock}>Тип клиента</div>
          <div className={styles.rightBlock}>
            <Select
              options={[
                { value: 'individual', label: 'Физ. лицо' },
                { value: 'legal', label: 'Юр. лицо' },
              ]}
              value={
                clientType
                  ? {
                      value: clientType,
                      label: clientType === 'individual' ? 'Физ. лицо' : 'Юр. лицо',
                    }
                  : null
              }
              onChange={(selectedOption) => {
                if (selectedOption) {
                  setClientType(selectedOption.value as 'individual' | 'legal')
                  setSelectedClient(undefined)
                  setFieldValue('clientId', '')
                }
              }}
              className={styles.selectInput}
              classNamePrefix='react-select'
              isClearable={false}
              placeholder='Выберите тип клиента'
              styles={{
                singleValue: (provided) => ({
                  ...provided,
                  color: clientType ? 'black' : provided.color,
                }),
                control: (provided) => ({
                  ...provided,
                  border: 'none',
                  boxShadow: 'none',
                  minHeight: 'auto',
                  backgroundColor: 'transparent',
                }),
                menu: (provided) => ({
                  ...provided,
                  right: 0,
                  overflow: 'auto',
                  height: 'auto',
                }),
                input: (provided) => ({
                  ...provided,
                  margin: 0,
                  padding: 0,
                  height: isMobile ? 44 : 20,
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  padding: 0,
                }),
                dropdownIndicator: (provided) => ({
                  ...provided,
                  padding: 0,
                }),
                indicatorSeparator: () => ({
                  display: 'none',
                }),
              }}
            />
          </div>
        </div>
        <div className={styles.clientBlock}>
          <div className={styles.leftBlock}>Клиент</div>
          <div className={styles.rightBlock}>
            {clients && clients.length > 0 ? (
              <AsyncSelect
                cacheOptions
                defaultOptions={clientOptions}
                loadOptions={loadOptions}
                onChange={(selectedOption) => {
                  const clientIdValue = String(selectedOption?.value || '')
                  setFieldValue('clientId', clientIdValue)
                  setSelectedClient(selectedOption?.value || '')
                }}
                onBlur={handleBlur}
                value={
                  values?.clientId || selectedClient
                    ? clientOptions.find(
                        (opt: any) =>
                          opt?.value === values?.clientId || opt?.value === selectedClient,
                      )
                    : null
                }
                placeholder='Выберите клиента...'
                isSearchable
                className={styles.selectInput}
                styles={{
                  singleValue: (provided) => ({
                    ...provided,
                    color: selectedClient ? 'black' : provided.color,
                  }),
                  control: (provided) => ({
                    ...provided,
                    border: 'none',
                    boxShadow: 'none',
                    minHeight: 'auto',
                    backgroundColor: 'transparent',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    right: 0,
                    overflow: 'auto',
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    height: '100%',
                    maxHeight: '150px',
                    overflowY: 'auto',
                  }),
                  input: (provided) => ({
                    ...provided,
                    margin: 0,
                    padding: 0,
                    height: isMobile ? 44 : 20,
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                }}
              />
            ) : (
              <div className={styles.companyBlock}>Нет доступных клиентов</div>
            )}
          </div>
        </div>
        <div className={styles.createClientBlock}>
          <button onClick={onOpenCreateClient}>
            <img src={plusIcon} />
            Создать Клиента
          </button>
        </div>
        {values?.manager && (
          <div className={styles.clientBlock}>
            <div className={styles.leftBlock}>Менеджер</div>
            <div className={styles.rightBlock}>
              <div className={styles.companyBlock}>{values?.manager}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
